module.exports = __webpack_public_path__ + "img/zz2.28a09800.png";